import { useTranslation } from 'react-i18next';

export default function FinalCTA() {
  const { t } = useTranslation('home');

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="contact" className="py-20 sm:py-28 md:py-36 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4 sm:mb-6 leading-tight px-4">
          {t('finalCta.title')}
        </h2>
        <p className="text-base sm:text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto mb-8 sm:mb-10 px-4">
          {t('finalCta.description')}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center mb-6 sm:mb-8 px-4">
          <a
            href="mailto:david@novaventure.be"
            className="w-full sm:w-auto bg-teal-600 text-white px-8 sm:px-12 py-4 sm:py-5 rounded-lg font-bold text-base sm:text-lg hover:bg-teal-700 transition-all hover:-translate-y-1 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-mail-line"></i>
            {t('finalCta.emailButton')}
          </a>
          <a
            href="tel:+32123456789"
            className="w-full sm:w-auto bg-slate-100 text-slate-900 px-8 sm:px-12 py-4 sm:py-5 rounded-lg font-semibold text-base sm:text-lg hover:bg-slate-200 transition-all hover:-translate-y-1 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-phone-line"></i>
            {t('finalCta.callButton')}
          </a>
        </div>
        <div className="space-y-2 px-4">
          <p className="text-sm sm:text-base text-slate-600">
            <strong>{t('finalCta.email')}</strong> <a href="mailto:david@novaventure.be" className="text-teal-600 hover:underline break-all">david@novaventure.be</a>
          </p>
          <p className="text-xs sm:text-sm text-slate-500">
            {t('finalCta.availability')}
          </p>
        </div>
      </div>
    </section>
  );
}
